export const outerHeight = (el) => {
    const height = el.offsetHeight;
    const style = getComputedStyle(el);
    return height + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
};
export const innerHeight = (el) => {
    const height = el.clientHeight;
    const style = getComputedStyle(el);
    return height - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
};
export const maxInnerHeight = (el) => {
    const style = getComputedStyle(el);
    return (parseFloat(style.maxHeight) || 0) - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
};
